// extracted by mini-css-extract-plugin
export var hotspots = "hotspots-module--hotspots--M4COq";
export var imgWrap = "hotspots-module--imgWrap--5xt4e";
export var header = "hotspots-module--header--gWkwc";
export var bkImage = "hotspots-module--bkImage--l057S";
export var caption = "hotspots-module--caption--kRdu1";
export var textBlockWrapper = "hotspots-module--textBlockWrapper--tekRH";
export var textBlock = "hotspots-module--textBlock--4euWB";
export var blockInner = "hotspots-module--blockInner--mJJAO";
export var desktopBlock = "hotspots-module--desktopBlock--4Ll20";
export var blockRight = "hotspots-module--blockRight--5s456";
export var blockLeft = "hotspots-module--blockLeft--2IUZ3";
export var blockTop = "hotspots-module--blockTop--og2G0";
export var blockBottom = "hotspots-module--blockBottom--jfwZE";
export var blockSubtitle = "hotspots-module--blockSubtitle--PRn2B";
export var textBlockActive = "hotspots-module--textBlockActive--pGgS6 hotspots-module--textBlock--4euWB";
export var mobileTextBlockWrapper = "hotspots-module--mobileTextBlockWrapper--5vYQH";
export var mobileBlock = "hotspots-module--mobileBlock--GwuDn";
export var marker = "hotspots-module--marker--t97Zh";
export var spotPulse = "hotspots-module--spotPulse--M0OF-";
export var mobileBorder = "hotspots-module--mobileBorder--1v4x+";
export var largeSpots = "hotspots-module--largeSpots--JfEvi";
export var spotPulseLg = "hotspots-module--spotPulseLg--i3ySP";
export var markerActive = "hotspots-module--markerActive--tpNBh hotspots-module--marker--t97Zh";
export var slideUp = "hotspots-module--slideUp--agIJi";
export var slideUpLarge = "hotspots-module--slideUpLarge--qQ-4B";